import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/components/ProductGridClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
